/**
 * Utility functions for iframe detection and handling
 */

/**
 * Checks if the current window is running inside an external iframe
 *
 * @returns {boolean} True if running in external iframe context
 */
export const isExternalIFrame = (): boolean => {
  // Check if we're in an iframe
  const isInIframe = window.self !== window.top;

  return isInIframe;
};
